import React, { useContext } from "react";
import styled from "@emotion/styled";
import Container from "@src/components/Container";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { theme } from "@src/components/nessie-web";

const FootnoteContainer = styled.section`
  padding: 16px 0;
  background-color: ${theme.colors.taro90};
`;

const FootnoteText = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #ffffff;
  margin: 0;
`;

type RedesignFootnoteProps = {
  footnote_text: string;
};

const RedesignFootnote: React.FC<RedesignFootnoteProps> = ({ footnote_text }) => {
  const t = useContext(TranslationContext);

  return (
    <>
      <FootnoteContainer>
        <Container>
          {footnote_text && (
            <FootnoteText>
              <sup>1</sup>
              {t.translate(footnote_text)}
            </FootnoteText>
          )}
        </Container>
      </FootnoteContainer>
    </>
  );
};

export default RedesignFootnote;
